/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type FeatureFlagScope = typeof FeatureFlagScope[keyof typeof FeatureFlagScope];


export const FeatureFlagScope = {
  Global: 'Global',
  Company: 'Company',
  User: 'User',
} as const;
